/**
 * Formatiert einen Datumsstring von einem Format in ein anderes.
 *
 * @param {string} value - Der zu formatierende Datumsstring.
 * @param {string} inputFormat - Das Format des Eingabedatumsstrings.
 * @param {string} outputFormat - Das gewünschte Format des Ausgabedatumsstrings.
 * @returns {string} Der formatierte Datumsstring, oder "00.00.0000" wenn der Eingabewert leer ist.
 */
export function formatDate(value, inputFormat, outputFormat) {
  // Wenn der Eingabewert undefiniert ist, sofort zurückkehren
  if (value === undefined) {
    return;
  }
  if (value === true) {
    return;
  }
  if (value === false) {
    return;
  }
  // Eine Zuordnung von Eingabeformaten zu Ausgabeformaten definieren
  const formats = {
    "YYYY-MM-DD": {
      "DD.MM.YYYY": (value) => value.substring(8, 10) + "." + value.substring(5, 7) + "." + value.substring(0, 4),
      YYYYDDMM: (value) => value.substring(0, 4) + value.substring(5, 7) + value.substring(8, 10),
      "MM/DD/YYYY": (value) => value.substring(5, 7) + "/" + value.substring(8, 10) + "/" + value.substring(0, 4),
    },
    "YYYYMM":{
      "MM/YYYY": (value) => value.substring(4, 6) + "/" + value.substring(0, 4)
    },
    YYYYMMDD: {
      "DD.MM.YYYY": (value) => value.substring(6, 8) + "." + value.substring(4, 6) + "." + value.substring(0, 4),
      YYYYDDMM: (value) => value.substring(0, 4) + value.substring(4, 6) + value.substring(6, 8),
      "MM/DD/YYYY": (value) => value.substring(4, 6) + "/" + value.substring(6, 8) + "/" + value.substring(0, 4),
    },
    "MM/DD/YYYY": {
      "YYYY-MM-DD": (value) => value.substring(6, 10) + "-" + value.substring(0, 2) + "-" + value.substring(3, 5),
      "DD.MM.YYYY": (value) => value.substring(3, 5) + "." + value.substring(0, 2) + "." + value.substring(6, 10),
      YYYYMMDD: (value) => value.substring(6, 10) + value.substring(0, 2) + value.substring(3, 5),
    },
    "DD.MM.YYYY": {
      "YYYY-MM-DD": (value) => value.substring(6, 10) + "-" + value.substring(3, 5) + "-" + value.substring(0, 2),
      YYYYMMDD: (value) => value.substring(6, 10) + value.substring(3, 5) + value.substring(0, 2),
      "MM/DD/YYYY": (value) => value.substring(3, 5) + "/" + value.substring(0, 2) + "/" + value.substring(6, 10),
    },
    YYYYMMDDTHHMMSS: {
      "YYYY-MM-DDTHH:mm:ss": (value) =>
        value.substring(0, 4) +
        "-" +
        value.substring(4, 6) +
        "-" +
        value.substring(6, 8) +
        "T" +
        value.substring(8, 10) +
        ":" +
        value.substring(10, 12) +
        ":" +
        value.substring(12, 14),
    },
  };

  // Überprüfen, ob das Eingabeformat unterstützt wird und das Ausgabeformat für das Eingabeformat verfügbar ist
  if (inputFormat in formats && outputFormat in formats[inputFormat]) {
    // Wenn der Eingabewert leer ist, einen Standardwert zurückgeben
    if (value?.replace(/\-/g, "")?.replace(/\ /g, "") === "") {
      return "00.00.0000";
    }
    // Ansonsten die Formatkonvertierungsfunktion auf den Eingabewert anwenden
    return formats[inputFormat][outputFormat](value);
  }
}
    